export default __webpack_public_path__ + "static/media/whoweare.1a5a8b4e.webp";